import React from "react";
import MainImg from "../../../assets/illustrations2/PNG/homepage_verified_leads.png";
import MainImg2 from "../../../assets/illustrations2/PNG/g-sheets_page_v-a.png";
import MainImg3 from "../../../assets/illustrations2/PNG/build_automation_using_API.png";
import MainImg4 from "../../../assets/illustrations/PNG/find_emails_in_bullk.png";
import MainImg5 from "../../../assets/illustrations2/PNG/extension_page_illustration.png";
import MainImg6 from "../../../assets/illustrations2/PNG/emails_using_our_extensive_Search.png";
import cardimg from "../../../assets/SC.png";
import Line from "../../../assets/line2.svg";
import UnderImg from "../../../assets/under.svg";
// import { FaCheck } from "react-icons/fa";
import check from "../../../assets/check.svg"

const sectionsData = [
  {
    id: 1,
    img: MainImg4,
    order: { imgOrder: "md:order-2", textOrder: "md:order-1" },
    heading: "Easily Find",
    highlight: "Email Addresses!",
    description:
      "Find any email address with a name, company, or LinkedIn profile. Process up to 1,000 emails in just 5 minutes and quickly expand your network.",
  },
  {
    id: 2,
    img: MainImg3,
    order: { imgOrder: "md:order-1", textOrder: "md:order-2" },
    heading: "Connect Your Tools with Our",
    highlight: "API!",
    description:
      "Make your work easier by connecting our email finder API to your existing tools. Automate your workflow and save time on repetitive tasks. Our API makes it easy to create custom automation solutions that fit your needs.",
  },
  {
    id: 3,
    img: MainImg2,
    order: { imgOrder: "md:order-2", textOrder: "md:order-1" },
    heading: "Look Up Emails in",
    highlight: "Google Sheets!",
    description:
      "Find and verify email addresses with direct integration in your Google Sheets. No more switching between tools. Our intuitive tool integrates with your spreadsheet, allowing you to search for emails using names, domains, or other criteria with just a few clicks.",
  },
  {
    id: 4,
    img: MainImg5,
    order: { imgOrder: "md:order-1", textOrder: "md:order-2" },
    heading: "Find Emails While You",
    highlight: "Browse!",
    description:
      "Easily retrieve verified email addresses as you browse LinkedIn, company websites or any online platform. Our browser extension helps you connect with potential leads without interrupting your workflow.",
  },
  {
    id: 5,
    img: MainImg6,
    order: { imgOrder: "md:order-2", textOrder: "md:order-1" },
    heading: "Find Emails",
    highlight: "Your Way!",
    description:
      "Our email solution is comprehensive and versatile to improve your outreach and networking potential. Find emails by name, domain, company, decision-maker, or LinkedIn profile. Our advanced search methods ensure you get reliable accurate contact information for individuals or entire organizations.",
  },
];

const handlenav = () => {
  window.location.href = process.env.REACT_APP_BASE_URL;
};

export default function TestimonialTwo() {
  return (
    <>
      <div className="bg-white px-8 pt-8 pb-6 lg:pb-0 flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="text-left md:w-[55%] md:order-1 md:p-6">
          <h2 className="text-3xl text-[#15223F] sm:text-4xl lg:text-[2.5rem] lg:leading-[3.75rem] font-bold">
            Pay only for{" "}
            <span className="relative inline-block">
              verified
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            emails
          </h2>
          <p className="text-xl md:text-[22px] my-4">
            Every email is thoroughly checked to ensure 97%+ delivery rates.
          </p>
          <p className="text-xl md:text-[22px] my-4">
            Use them confidently in campaigns and protect your sender reputation
          </p>
          <ul className="text-xl md:text-[22px] my-4 space-y-5 font-semibold">
            <li className="flex items-center">
              {/* <FaCheck className="text-[#4F7FFF] mr-6 text-xl mt-1" /> */}
              <img src={check} alt="Checkmark" className="mr-3 -ml-3 -mt-[1px] w-12 h-12" />
              Partially Verified Emails are FREE
            </li>
            <li className="flex items-center">
              {/* <FaCheck className="text-[#4F7FFF] mr-6 text-xl mt-1" /> */}
              <img src={check} alt="Checkmark" className="mr-3 -ml-3 -mt-[1px] w-12 h-12" />
              Not Found results are FREE
            </li>
            <li className="flex items-center">
              {/* <FaCheck className="text-[#4F7FFF] mr-6 text-xl mt-1" /> */}
              <img src={check} alt="Checkmark" className="mr-3 -ml-3 -mt-[1px] w-12 h-12" />
              Duplicate searches within one year are FREE
            </li>
          </ul>
        </div>

        <div className="flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-2">
          <img
            src={MainImg}
            alt="Dashboard preview"
            className="md:w-full w-96"
          />
        </div>
      </div>
      <div
        className="flex flex-col items-center justify-center p-8 h-96 mt-2 md:mt-12 bg-cover bg-center"
        style={{ backgroundImage: `url(${cardimg})` }}
      >
        <h1 className="text-2xl sm:text-4xl lg:text-[3rem] text-white mb-8 !leading-[3.5rem] font-bold text-center lg:px-24">
          Confidently Find Any Email with Precision, Reliable and
          <br />
          Verified Results for Confidence!
        </h1>
        <div className="text-center w-full flex justify-center">
          <button
            onClick={handlenav}
            className="text-[#1A1A1A] bg-white font-semibold p-3 rounded-md w-[220px]"
          >
            3 Days Risk FREE Trial
          </button>
        </div>
      </div>

      <h2 className="text-3xl bg-[#F6F6F7] pt-8 sm:text-4xl lg:text-[48px] lg:leading-[3.75rem] font-bold text-center py-10 md:pt-16">
        Connect with the Right{" "}
        <span className="relative inline-block">
          Business People{" "}
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>{" "}
      </h2>
      <div className="bg-[#F6F6F7] p-8">
        {sectionsData.map((section) => (
          <div
            key={section.id}
            className="flex flex-col md:flex-row md:items-center md:justify-between mb-10"
          >
            <div
              className={`flex justify-center items-center mt-10 md:mt-0 md:w-[45%] ${section.order.imgOrder}`}
            >
              <img
                src={section.img}
                alt="Expanded section preview"
                className="md:w-full w-96"
              />
            </div>

            <div
              className={`text-left md:w-[55%] ${section.order.textOrder} md:p-6`}
            >
              <h2 className="text-3xl sm:text-4xl lg:text-[2.5rem] lg:leading-[2.5rem] font-bold">
                {section.heading}{" "}
                <span className="relative inline-block">
                  {section.highlight}
                  <img
                    src={Line}
                    alt="Underline decoration"
                    className="absolute bottom-0 left-0 w-full top-9 lg:top-12"
                  />
                </span>
              </h2>
              <p className="text-[22px] my-6 lg:mb-12">{section.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div>
        <img src={UnderImg} alt="Bottom decoration" className="w-full h-14" />
      </div>
    </>
  );
}
